var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",on:{"click":_vm.onClick}},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"checkbox",class:{active:_vm.active==true}})]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }